module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/clone.js
// module id = 170
// module chunks = 1